var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.78
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Validera-konto-Copy-3",
    transform: "translate(-447.000000, -352.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(414.000000, 312.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconmonstr-user-20",
    transform: "translate(33.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,0 C10.746,0 0,10.746 0,24 C0,37.254 10.746,48 24,48 C37.254,48 48,37.254 48,24 C48,10.746 37.254,0 24,0 Z M39.506,36.61 C38.984,35.438 37.928,34.628 35.764,34.128 C31.178,33.07 26.908,32.142 28.978,28.238 C35.268,16.354 30.644,10 24,10 C17.224,10 12.712,16.598 19.022,28.238 C21.154,32.166 16.726,33.092 12.236,34.128 C10.068,34.628 9.02,35.444 8.502,36.62 C5.692,33.174 4,28.782 4,24 C4,12.972 12.972,4 24,4 C35.028,4 44,12.972 44,24 C44,28.778 42.31,33.166 39.506,36.61 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.cae9a0f4dc408abafebc21f8b3230ec3.svg";
export { ForwardRef as ReactComponent };